import { number } from "@intlify/core-base";
import { Dictionary, isNumber } from "lodash";
import { useI18n } from "vue-i18n";
export const DayOfWeekToIso: Dictionary<number> = {
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6,
  SU: 7,
};
export enum Permissions {
  ViewOrders = 1,
  EditOrders = 2,
  ChangeOrderStatus = 3,
  CreateReceipts = 4,
  CreateInvoices = 5,
  CreateCreditInvoices = 6,
  GenerateLinkOfPersonalAreaToOrder = 7,
  DocumentViewSearch = 8,
  DocumentShare = 9,
  ReportsView = 10,
  ProductsViewSearch = 11,
  CalendarViewFilter = 12,
  CalendarStopSale = 13,
  EditProducts = 14,
  CreateProducts = 15,
  ViewProviderSettings = 16,
  EditProviderSettings = 17,
  CreateOrders = 27,
  Cashier = 28,
  CashierReservedOrders = 29,
  CashierSellToPrivate = 30,
  CashierSellToBusiness = 31,
  CashierClubsVouchers = 32,
  CashierChangeRate = 33,
  ChangeUnitPrice = 34,
  CashierChangeDiscount = 35,
  CashierEditSLot = 36,
  CreatePerfomaInvoices = 37,
  CanCancelExistingReceipt = 38,
  CreateBulkInvoices = 39,
  CreateChangeOrderInPast = 40,
  CreateChangeSlotInPast = 41
}

export enum PaymentType {
  Cash = 1,
  Check = 2,
  CreditCard = 4,
  BankTransfer = 8,
}

export enum OrderStatus {
  OK = 1,
  RQ = 2,
  CN = 3,
  ERR = 4,
}

export enum OrderBlockTypes {
  minutes = 0,
  hours = 1,
  days = 2
}

export const DayOfWeekKendo = {
  Sunday: 'SU',
  Monday: 'MO',
  Tuesday: 'TU',
  Wednesday: 'WE',
  Thursday: 'TH',
  Friday: 'FR',
  Saturday: 'SA'
};

export enum OrderBlockOption {
  before = 1,
  after = 2,
  allow = 3
}

export enum OrderStatusColors {
  "#79D217" = 1,
  "#FD695A" = 2,
  "#625C82" = 3,
  "" = 4,
}
export enum PriceTypeCategory {
  Local = 1,
  Tourist = 2,
  Individual = 4,
  Group = 8,
  Club = 16,
}
export enum CreditCardPaymentType {
  Regular = 1,
  Credit = 2,
  Payments = 3,
}

export enum ProductRegistrationType {
  RegistrationIsRequired = 1,
  RegistrationIsNotRequired = 2,
  NotForSale = 3,
}

export enum PrintingType {
  SingleUnitTicket = 1,
  MultipleUnitTicket = 2,
  OrderSummaryDocument = 3,
}

export function ToOptions(e: any, prefix = "") {
  return Object.entries(e)
    .filter((x) => typeof x[0] === "string" && isNumber(x[1]))
    .map((x) => {
      return {
        id: x[1],
        name: useI18n().t(prefix + x[0]),
      };
    });
}

export const convertArrayToObject = (array, key, val) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item[val],
    };
  }, initialValue);
};

export enum Lang {
  "en-US" = "EN",
  "he-IL" = "HE",
  "ru-RU" = "RU",
}

export enum CouponLimitationType {
  CustomerQuantity = 1,
  TotalAmount = 2,
}

export enum PrintSize {
  A4,
  Check_8cm
}

export enum OrderSearchType{
  OrderNumber = 1,
  Ticket = 2
}
export enum CouponDiscountType {
  Discount = 1,
  TicketFixedUnitPrice = 2,
  NoDiscount = 3
}
export enum CouponType {
  Regular = 1,
  NextPurchase = 2,
  BusinessClientAgreement = 3
}
export enum CouponWhoFinances {
    NoFinance = 1,
    EntireOrder = 2,
    Discount = 3
}